export const OnboardingRoutes = {
  ROOT: '/onboarding',
  CHOOSE_CARD_THEME: '/onboarding/choose-card-theme-category',
  KYC: '/onboarding/kyc',
  ADD_KID_PERSONAL_INFO: '/onboarding/add-kid/personal-info',
  REQUEST_PHYSICAL_CARD: '/onboarding/request-physical-card',
  DOWNLOAD_APP: '/onboarding/download-app',
} as const;

export const ONBOARDING_TEEN_FIRST_NAME = 'ONBOARDING_TEEN_FIRST_NAME';
export const ONBOARDING_TEEN_LAST_NAME = 'ONBOARDING_TEEN_LAST_NAME';
